export default {
    url: '/pool/:poolId?page&keyword&metaSearch&categoryId&createdBy&sort&externalId',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/pools/pool/index.js